__turbopack_context__.v({
  "dropdown": "selectField-module-scss-module__odZs4a__dropdown",
  "dropdown-container": "selectField-module-scss-module__odZs4a__dropdown-container",
  "dropdown-container-default": "selectField-module-scss-module__odZs4a__dropdown-container-default",
  "dropdown-container-default-medium": "selectField-module-scss-module__odZs4a__dropdown-container-default-medium",
  "dropdown-container-disabled": "selectField-module-scss-module__odZs4a__dropdown-container-disabled",
  "dropdown-container-medium": "selectField-module-scss-module__odZs4a__dropdown-container-medium",
  "dropdown-container-opened": "selectField-module-scss-module__odZs4a__dropdown-container-opened",
  "dropdown-container-text": "selectField-module-scss-module__odZs4a__dropdown-container-text",
  "dropdown-container-text-disabled": "selectField-module-scss-module__odZs4a__dropdown-container-text-disabled",
  "dropdown-error": "selectField-module-scss-module__odZs4a__dropdown-error",
  "dropdown-error-text": "selectField-module-scss-module__odZs4a__dropdown-error-text",
  "dropdown-error-text-hide": "selectField-module-scss-module__odZs4a__dropdown-error-text-hide",
  "dropdown-field": "selectField-module-scss-module__odZs4a__dropdown-field",
  "dropdown-list": "selectField-module-scss-module__odZs4a__dropdown-list",
  "dropdown-list-item": "selectField-module-scss-module__odZs4a__dropdown-list-item",
  "dropdown-list-item-medium": "selectField-module-scss-module__odZs4a__dropdown-list-item-medium",
  "dropdown-list-item-selected": "selectField-module-scss-module__odZs4a__dropdown-list-item-selected",
  "dropdown-name": "selectField-module-scss-module__odZs4a__dropdown-name",
});
